import { ArrowDownIcon, IconButton } from '@blueprinthq/joy'
import { Box, Input, InputGroup, InputRightElement } from '@chakra-ui/react'
import React, { forwardRef } from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import type { FormikErrors } from 'formik'

interface BPDatePickerProps {
  selected: Date | null
  onChange: (date: Date | null) => void
  placeholder?: string
  width?: string
  errors?: FormikErrors<Date>
}

export const BPDatePicker: React.FC<BPDatePickerProps> = ({
  selected,
  onChange,
  placeholder = 'Select date',
  width = '100%',
  errors
}) => {
  // Forward Chakra-styled input to react-datepicker
  const CustomInput = forwardRef<HTMLInputElement, any>(
    ({ value, onClick }, ref) => (
      <Box
        borderBottom="1px solid rgba(87, 89, 91, 0.04)"
        borderRadius="6px"
        width={width}
        _focus={{
          borderBottom: 'solid 2px primary'
        }}
      >
        <InputGroup maxWidth="115px">
          <Input
            ref={ref}
            value={value}
            onClick={onClick}
            placeholder={placeholder}
            readOnly
            cursor="pointer"
            p="0px"
            border="none"
            isInvalid={!!errors}
          />
          <InputRightElement width="20px" gap="0px">
            <IconButton
              icon={<ArrowDownIcon />}
              onClick={onClick}
              aria-label="Open date picker"
              variant="ghost"
              size="sm"
              color="gray.400"
              borderRadius="8px"
            />
          </InputRightElement>
        </InputGroup>
      </Box>
    )
  )

  return (
    <DatePicker
      selected={selected}
      onChange={onChange}
      customInput={<CustomInput />}
      dateFormat="MMM dd yyyy"
    />
  )
}
